import { ErrorScreen } from '@/components/shared/ErrorScreen/ErrorScreen';
import { LinkExpiredScreen } from '@/components/shared/LinkExpiredScreen/LinkExpiredScreen';
import { jwtDecode } from 'jwt-decode';
import { useMemo, useState } from 'react';
import AccountSetupStep from './steps/AccountSetupStep/AccountSetupStep';
import { WelcomeStep } from './steps/WelcomeStep/WelcomeStep';
import { tokenSchema, type DecodedInvitationToken } from './types';

type Step = 'welcome' | 'accountSetup';

export const RegisterSteps = ({ token }: { token: string }) => {
  const [currentStep, setCurrentStep] = useState<Step>('welcome');

  const decodedToken = useMemo(() => jwtDecode<DecodedInvitationToken>(token), [token]);

  const parsedState = tokenSchema.safeParse(decodedToken);

  if (!parsedState.success) {
    return <ErrorScreen />;
  }

  const isTokenExpiredOnClient = parsedState.data.exp * 1000 < Date.now();

  if (isTokenExpiredOnClient) {
    return <LinkExpiredScreen />;
  }

  const steps = {
    welcome: <WelcomeStep invitationToken={token} goToNextStep={() => setCurrentStep('accountSetup')} firstName={parsedState.data.FirstName} />,
    accountSetup: <AccountSetupStep decodedToken={parsedState.data} token={token} />,
  };

  const currentStepComponent = steps[currentStep];

  return <div>{currentStepComponent}</div>;
};
